export default "__VITE_PUBLIC_ASSET__45ccd35c__"